/* =========================================================
   Campo de contraseña con botón de revelar.

   Existe porque en este portal las contraseñas no se eligen: ETC las
   genera y las entrega por teléfono o en persona, largas y con signos.
   Teclear quince caracteres a ciegas y que el portal conteste
   «credenciales incorrectas» no dice si falló el dedo o la contraseña,
   y a la tercera vez la cuenta se bloquea.

   Nace oculto siempre. Revelar es una decisión de quien está delante de
   la pantalla, nunca el estado por defecto: puede haber alguien detrás.
   El botón no viaja en el tabulador (`tabIndex={-1}`) para que pasar del
   campo al de al lado con el teclado no lo pise.
   ========================================================= */
import React from 'react';
import { ic, sized } from '@/components/Icons';
import { useI18n } from '@/i18n';

export interface PasswordInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Espacio que hay que reservar a la derecha para el botón. */
  anchoBoton?: number;
}

export function PasswordInput({ style, anchoBoton = 40, ...resto }: PasswordInputProps) {
  const { lang } = useI18n();
  const es = lang === 'es';
  const [visible, setVisible] = React.useState(false);

  return (
    <div style={{ position: 'relative', display: 'flex' }}>
      <input
        {...resto}
        type={visible ? 'text' : 'password'}
        style={{ ...style, flex: 1, minWidth: 0, paddingRight: anchoBoton + 2 }}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        aria-pressed={visible}
        aria-label={visible
          ? (es ? 'Ocultar la contraseña' : 'Hide password')
          : (es ? 'Mostrar la contraseña' : 'Show password')}
        data-tip={visible ? (es ? 'Ocultar' : 'Hide') : (es ? 'Mostrar' : 'Show')}
        style={{
          position: 'absolute', right: 1, top: 1, bottom: 1, width: anchoBoton,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          background: 'none', border: 'none', borderRadius: '0 8px 8px 0', padding: 0,
          color: visible ? 'var(--brand-primary)' : 'var(--text-3)',
          cursor: resto.disabled ? 'not-allowed' : 'pointer',
          opacity: resto.disabled ? 0.5 : 1,
        }}
      >
        {sized(visible ? ic.eyeOff : ic.eye, 17)}
      </button>
    </div>
  );
}
